import type { SVGAttributes } from 'react';

export const svgProps: SVGAttributes<SVGElement> = {
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'none',
  'aria-hidden': true,
};
